import { useState } from 'react';
import { useSelector } from 'react-redux';
import { UserPlusIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import {
  Dialog,
  DialogTitle,
  DialogDescription,
  DialogBody,
  DialogActions,
} from '../components_catalyst/dialog';
import { Button } from '../components_catalyst/button';
import { useCurrentMap } from '../hooks/useCurrentMap';
import { selectUserRoleForMap } from '../store/selectors';
import { RootState } from '../store/store';

export function RequestAccessButton() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // Get current user's role for tooltip
  const currentMap = useCurrentMap();
  const role = useSelector((state: RootState) =>
    currentMap ? selectUserRoleForMap(state, currentMap.uuid) : null,
  );

  // Generate role-aware tooltip
  const getTooltip = (userRole: string | null) => {
    if (userRole === 'commenter' || userRole === 'viewer') {
      return `You are a ${userRole}. Click to request access and invitations.`;
    }
    return 'Request access to share this map';
  };

  return (
    <aside aria-label="Request Access">
      <div className="flex">
        <button
          onClick={() => setIsDialogOpen(true)}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-l-md hover:bg-gray-50 cursor-pointer"
          title={getTooltip(role)}
        >
          <UserPlusIcon className="h-5 w-5" />
          <span>Share</span>
        </button>
        <button
          className="px-2 py-2 bg-white border border-l-0 border-gray-300 rounded-r-md hover:bg-gray-50 cursor-pointer"
          onClick={() => setIsDialogOpen(true)}
          title={getTooltip(role)}
        >
          <ChevronDownIcon className="h-5 w-5 text-gray-700" />
        </button>
      </div>

      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <div className="p-6 max-w-md">
          <DialogTitle>Sharing Permissions Required</DialogTitle>
          <DialogDescription>
            You need editor access to share this milestone map with others.
          </DialogDescription>
          <DialogBody>
            <p className="text-sm text-gray-600">
              Only map owners and editors can invite new people to collaborate. Contact the map
              owner to request editor access if you need to share this map.
            </p>
            <p className="text-sm text-gray-500 mt-3">
              <strong>Coming soon:</strong> Request access feature will be available in a future
              update.
            </p>
          </DialogBody>
          <DialogActions>
            <Button onClick={() => setIsDialogOpen(false)}>Got it</Button>
          </DialogActions>
        </div>
      </Dialog>
    </aside>
  );
}
